// Import react
import React, { useState, useEffect } from "react";

// Import states, contexts, and CSS
import { useActiveUser } from "../../store/activeUserContext";

import { SpinnerGeneric } from "../../utils/general/spinners";
import { Card, Form, Row, Col, Button, Table } from "react-bootstrap";
import { PlusCircle } from "react-bootstrap-icons";


const CurrentProdList = () => {
  // Get user data from context
  const { activeUser } = useActiveUser();

  // Get variables from local storage
  const userId = activeUser._id;
  const token = localStorage.getItem("token");

  return (
    <div>
      {/* Utente registrato */}
      <Row>
        <Col xs={12} lg={12}>
          {activeUser ? (
            <>
              <div>Utente registrato: {activeUser._id}</div>
              <div>Nome utente: {activeUser.firstName}</div>
            </>
          ) : (
            <div>Nessun utente registrato.</div>
          )}
        </Col>
      </Row>

      {/* Tabella Materiali */}
      <Row>
        <Col xs={12} lg={12}>
          <Card className="mt-4 mb-5">
            <Card.Header>
              <Card.Title>Current Prod Table</Card.Title>
            </Card.Header>
            <Card.Body>
              <Table bordered hover>
                <thead>
                  <tr>
                    <th>Current Prod Id</th>
                    <th>Current Prod Type</th>
                    <th>Current Prod Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr >
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CurrentProdList;
